/*
USE CASE: UserUnlock
Desc: Retorna do servidor o status do usuário 200 
params: 
   - item: objeto com os dados do usuário a ser verificado
returns:
  - Uma promise que retorna resolve para autorizado 
  
*/
import { Button, IconButton } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import React, { useEffect, useState } from 'react';
import APIManager from '../connection/APIManager';
import AuthBuildHeaderUserObject from './AuthBuildHeaderUserObject';

const UserUnlockOrLock = (user_id) => {
    return new Promise(async (resolve, reject) => {
      let obj = await AuthBuildHeaderUserObject().catch(e => {return null})
      if(!obj) reject()

      let headers = {
          ...obj        
      }

      APIManager.send('/usuarios/unlockorlock','PUT',headers,{user_id: user_id}).then(res => {
        return res.json();
      }).then(json => {
        resolve(json)
      }).catch(e => {
        reject(e)
      })
    })
}
export default UserUnlockOrLock;